import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { ChangeSearchForm } from 'src/common/components/search/playback/internals/change-search-form';
import { CollapsibleSearchForm } from 'src/common/components/search/playback/internals/collapsible-search-form';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { SearchForm } from '@shared-ui/retail-search-tools-multi-item';
import { ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';
export const MitSearchFormWrapper = inject('packageType')(observer(({
  packageType
}) => {
  if (!packageType) {
    return React.createElement(LegacyMitSearchForm, null);
  }
  const inputs = {
    packageSearchCriteria: {
      primary: {}
    },
    packageType: packageType
  };
  return React.createElement(Experiment, {
    name: "TSDP_New_Search_Form_mWeb",
    logExposure: true
  }, React.createElement(ExperimentControl, null, React.createElement(LegacyMitSearchForm, null)), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement("div", {
    "data-stid": "mit-search-form"
  }, React.createElement(SearchForm, {
    inputs: inputs
  }))));
}));
export const LegacyMitSearchForm = observer(() => React.createElement(Viewport, null, React.createElement(ViewSmall, null, React.createElement(CollapsibleSearchForm, null)), React.createElement(ViewMedium, null, React.createElement(ChangeSearchForm, null))));
MitSearchFormWrapper.displayName = 'MitSearchFormWrapper';